import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { PageShell } from "./Overview";
import { ecosystemApi } from "@/lib/api";

const Settings = () => {
  const { user } = useAuth();
  const [products, setProducts] = useState([]);
  useEffect(() => { ecosystemApi.products().then(setProducts).catch(() => {}); }, []);

  return (
    <PageShell title="Settings" subtitle="Profile & account">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <Card title="Profile">
          <Row k="Name" v={user?.name} />
          <Row k="Email" v={user?.email} />
          <Row k="Company" v={user?.company || "—"} />
          <Row k="Member since" v={user ? new Date(user.created_at).toLocaleDateString() : "—"} />
        </Card>
        <Card title="Mahakali stack" cta={{ to: "/app/ecosystem", label: "Manage" }}>
          {products.map((p) => (
            <div key={p.id} className="flex items-center justify-between py-3 border-b border-border-subtle last:border-0" data-testid={`settings-product-${p.id}`}>
              <div className="flex items-center gap-3">
                <span className="w-1.5 h-1.5 rounded-full" style={{ background: p.color }} />
                <div>
                  <div className="text-sm">{p.name}</div>
                  <div className="text-xs text-ink-muted">{p.tagline}</div>
                </div>
              </div>
              <Link to="/app/ecosystem" className="text-[10px] font-mono-accent uppercase tracking-[0.2em] text-artha-amber hover:text-artha-cream">
                Configure →
              </Link>
            </div>
          ))}
        </Card>
      </div>
    </PageShell>
  );
};

const Card = ({ title, children, cta }) => (
  <div className="border border-border-subtle bg-surface-card p-6">
    <div className="flex items-end justify-between mb-4">
      <h2 className="h-display text-2xl">{title}</h2>
      {cta && <Link to={cta.to} className="text-xs font-mono-accent uppercase tracking-[0.2em] text-artha-amber hover:text-artha-cream">{cta.label}</Link>}
    </div>
    <div>{children}</div>
  </div>
);

const Row = ({ k, v }) => (
  <div className="flex justify-between py-3 border-b border-border-subtle last:border-0">
    <span className="text-xs font-mono-accent uppercase tracking-[0.2em] text-ink-muted">{k}</span>
    <span className="text-sm">{v}</span>
  </div>
);

export default Settings;
